import request from '@/utils/request'

/**
 * 获取轮播图广告列表
 * @returns {Promise}
 */
export function getAdList() {
    return request({
        url: '/ad/ad/getList',
        method: 'get'
    })
}
